/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Duration_SecondsInputs */



/**
* | output |
* | --- |
* | "in seconds" |
*
* @param {Transcript_Export_Duration_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_duration_seconds = /** @type {((inputs?: Transcript_Export_Duration_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Duration_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("en secondes")
	if (locale === "de") return /** @type {LocalizedString} */ ("in Sekunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("in secondi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("за секунды")
	if (locale === "es") return /** @type {LocalizedString} */ ("en segundos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("只需几秒钟")
	if (locale === "ja") return /** @type {LocalizedString} */ ("数秒で")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेकंडों में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("em segundos")
	return /** @type {LocalizedString} */ ("in seconds")
});